(function() {
  var Service,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Service = App.loadClass('core::Angular/Service');

  exports.MapsConversionService = (function(superClass) {
    var alphabeticalComparison;

    extend(MapsConversionService, superClass);

    function MapsConversionService(http, rootScope, window) {
      this.http = http;
      this.rootScope = rootScope;
      this.window = window;
      this.loadData = bind(this.loadData, this);
      this.triggerResize = bind(this.triggerResize, this);
      this.sort = bind(this.sort, this);
      this.loadData(this.http.post('backend/grower/maps-conversion/get-input-files'), 'input_files', 'sort');
      this.loadData(this.http.post('backend/grower/maps-conversion/get-matrix-rows'), 'matrix_rows');
      this.statusQueueTableOffset = 0;
      this.window.confirmation = (function(_this) {
        return function(data) {
          if (data.vps_count > 0) {
            _this.matrix_rows = true;
          }
          return _this.updateInputFileStatuses();
        };
      })(this);
    }

    MapsConversionService.prototype.sort = function() {
      return this.input_files.sort(alphabeticalComparison.bind(null, ['uploaded_at', 'status']));
    };

    alphabeticalComparison = function(columns, a, b) {
      var result;
      result = strnatcasecmp(a[columns[0]], b[columns[0]]);
      if (result === 0) {
        result = strnatcasecmp(a[columns[1]], b[columns[1]]);
      }
      return result;
    };

    MapsConversionService.prototype.triggerResize = function() {
      return this.statusQueueTableOffset += 1;
    };

    MapsConversionService.prototype.loadData = function(promise, key, callback) {
      if (callback == null) {
        callback = null;
      }
      promise.then((function(_this) {
        return function(response) {
          var ref, ref1;
          if ((response != null ? (ref = response.data) != null ? (ref1 = ref.status) != null ? ref1.type : void 0 : void 0 : void 0) === 'success') {
            _this[key] = response.data.data;
            if (callback) {
              return _this[callback]();
            }
          }
        };
      })(this));
      return promise;
    };

    return MapsConversionService;

  })(Service);

}).call(this);
